class OliveCartDrawer extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.bindDialog();
    this.addEventListener('click', event => {
      if (event.target.closest('[data-oc-close]')) this.close();
      const button = event.target.closest('[data-oc-quantity]');
      if (button) this.change(button.closest('[data-key]').dataset.key, Number(button.dataset.ocQuantity));
    });
    document.addEventListener('click', event => {
      const link = event.target.closest('.oh-cart-link');
      if (!link || event.ctrlKey || event.metaKey) return;
      event.preventDefault();
      this.activeElement = link;
      this.open();
      this.refresh().catch(error => this.showError(error.message));
    });
    document.addEventListener('submit', async event => {
      const form = event.target;
      if (event.defaultPrevented || !form.matches('form[id^="OHBuy-"]')) return;
      event.preventDefault();
      const button = event.submitter || form.querySelector('[name="add"]');
      if (form.dataset.ocBusy) return;
      form.dataset.ocBusy = 'true';
      this.activeElement = button;
      button?.setAttribute('aria-disabled', 'true');
      try {
        const body = new FormData(form);
        body.set('sections', this.dataset.section);
        body.set('sections_url', location.pathname);
        const response = await fetch(this.root() + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
        await this.refresh();
        this.open();
      } catch (error) {
        this.open();
        this.showError(error.message);
      } finally {
        delete form.dataset.ocBusy;
        button?.removeAttribute('aria-disabled');
      }
    });
  }
  root() { return window.Shopify?.routes?.root || '/'; }
  bindDialog() {
    const dialog = this.querySelector('dialog');
    dialog.addEventListener('cancel', event => {event.preventDefault(); this.close();});
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right)) this.close();
    });
  }
  open(trigger) {
    if (trigger) this.activeElement = trigger;
    const dialog = this.querySelector('dialog');
    if (!dialog.open) dialog.showModal();
    this.classList.add('active');
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.querySelector('dialog').close();
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    this.activeElement?.focus();
  }
  setActiveElement(element) { this.activeElement = element; }
  getSectionsToRender() { return [{id:this.dataset.section,selector:'#CartDrawer'}]; }
  async renderContents() { await this.refresh(); this.open(); }
  async refresh() {
    const url = new URL(location.href);
    url.searchParams.set('sections', this.dataset.section);
    url.searchParams.set('preview_theme_id', this.dataset.theme);
    const response = await fetch(url.toString(), {cache:'no-store'});
    if (!response.ok) throw new Error(this.dataset.error);
    const sections = await response.json();
    const html = sections[this.dataset.section];
    if (!html) throw new Error(this.dataset.error);
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
    const current = this.querySelector('dialog');
    current.querySelector('.oc-shell').replaceWith(next.querySelector('.oc-shell'));
    this.dataset.count = next.dataset.count;
    document.querySelectorAll('.oh-cart-link span').forEach(node => node.textContent = '(' + this.dataset.count + ')');
  }
  async change(id, quantity) {
    if (this.getAttribute('aria-busy') === 'true') return;
    this.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(this.root() + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
      await this.refresh();
      this.querySelector('.oc-close')?.focus();
    } catch (error) { this.showError(error.message); }
    finally { this.removeAttribute('aria-busy'); }
  }
  showError(message) { const node = this.querySelector('.oc-error'); node.textContent = message || this.dataset.error; node.hidden = false; }
}
if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', OliveCartDrawer);

